<template>
    <div>
        <div
            :ref="'div_main_elements'"
            :class="
                app.isSpinnerVisible || app.isSpinnerAlwaysVisible
                    ? 'd-none'
                    : ''
            "
        >
            <!-- ------------------------ -->
            <!--          NAVEGACIO       -->
            <!-- ------------------------ -->
            <navigation />

            <main-elements60-component
                ref="refmainElements60Component"
                v-if="idgama == '60s'"
            />
            <main-elements66-component
                ref="refmainElements66Component"
                v-else-if="idgama == '66' && idsolucionconstructiva !== '10-t_sop'"
            />
            <main-elements66simetric-component
                ref="refmainElements66Component"
                v-else-if="
                    true &&
                    idgama == '66' &&
                    idsolucionconstructiva == '10-t_sop'
                "
            />

            <main-elements67-component
                ref="refmainElements67Component"
                v-else-if="
                    idgama == '67' && idsolucionconstructiva !== '10-t_sop'
                "
            />
            <main-elements67simetric-component
                ref="refmainElements67Component"
                v-else-if="
                    true &&
                    idgama == '67' &&
                    idsolucionconstructiva == '10-t_sop'
                "
            />

            <main-elements68-component
                ref="refmainElements68Component"
                v-else-if="idgama == '68'"
            />
            <main-elements73-component
                ref="refmainElements73Component"
                v-else-if="idgama == '73'"
            />

            <!-- CANAL 73 CON CAJA DE MECANISMOS gama 73a  -->
            <main-elements73a-component
                ref="refmainElements73aComponent"
                v-else-if="idgama == '73a'"
            />

            <main-elements93-component
                ref="refmainElements93Component"
                v-else-if="idgama == '93'"
            />

            <main-elements80-component
                ref="refmainElements80Component"
                v-else-if="idgama == '80'"
            />

            <main-elements74-component
                ref="refmainElements74Component"
                v-else-if="idgama == '74'"
            />

            <main-elements78-component
                ref="refmainElements78Component"
                v-else-if="idgama == '78'"
            />

            <main-elements31-component
                ref="refmainElements31Component"
                v-else-if="idgama == '31'"
            />

            <main-elements30-component
                ref="refmainElements30Component"
                v-else-if="idgama == '30'"
            />

            <main-elements50c-component
                ref="refmainElements50Component"
                v-else-if="idgama == '50c' | idgama == '50cn'"
            />

            <main-elements50t-component
                ref="refmainElements50Component"
                v-else-if="idgama == '50t'"
            />

            <main-elements51-component
                ref="refmainElements51Component"
                v-else-if="idgama == '51'"
            />

            <main-elements52-component
                ref="refmainElements52Component"
                v-else-if="idgama == '52'"
            />

            <main-elements-generic-component v-else />

            <!-- ------------------------ -->
            <!--          NAVEGACIO       -->
            <!-- ------------------------ -->
            <navigation />
        </div>

        <!-- ---------------- -->
        <!-- BUTONS INFERIORS -->
        <!-- ---------------- -->

        <!-- <div
            class="d-flex flex-column justify-content-center align-items-center"
            :class="[
                    (idgama == 66 || idgama == 67) && isWall ? 'mt-4' : '',
                    (idgama == 66 || idgama == 67) && isCeiling && !isMobile && withSoporteTrapecio ? 'mt-5' : '',
                    (idgama == 66 || idgama == 67) && isCeiling && isMobile && withSoporteTrapecio ? 'mt-4' : '',
            ]"
        >
            <button
                type="button"
                class="btn btn_bottom_width text-wrap mt-3"
                :class="[
                        app.isSpinnerVisible || app.isSpinnerAlwaysVisible ? 'd-none' : '',
                        selectedAllParameters ? 'btn-dark font-weight-bold' : 'btn-outline-dark',
                        (idgama == 66 || idgama == 67) && idsolucionconstructiva =='10-t_sop' ? 'mt-4' : '',
                        (idgama == 66 || idgama == 67) && idsolucionconstructiva =='10-cliente' && !isMobile ? 'mt-4' : '',
                        (idgama == 66 || idgama == 67) && idsolucionconstructiva !=='10-cliente' && idsolucionconstructiva !=='10-t_sop' ? 'mt-5' : '',
                        idgama == 78 ? 'mt-4' : '',

                     ]"
                @click="navigate_p4"
            >
                <i v-if="buttonLoading" class="fa fa-spinner fa-spin"></i>
                {{ $t('s3_go_to_results') }}
            </button>
            <button
                type="button"
                class="btn mt-3 btn-outline-secondary btn_bottom_width text-wrap"
                :class="app.isSpinnerVisible || app.isSpinnerAlwaysVisible ? 'd-none' : ''"
                @click.stop="cleanAllSelectors"
            >{{ $t('s2_delete_current_selection') }}
            </button>
            <button
                type="button"
                class="btn mt-3 mb-5 btn-outline-secondary btn_bottom_width text-wrap"
                :class="app.isSpinnerVisible || app.isSpinnerAlwaysVisible ? 'd-none' : ''"
                style="margin: 0px 0px 130px 0px"
                @click="navigate_p2"
            >
                <i v-if="buttonLoading" class="fa fa-spinner fa-spin"></i>
                {{ $t('modify_configuration_btn') }}
            </button>
        </div> -->
    </div>
</template>

<script>
import { app } from "../../application.js";
import editParameterValueComponent from "./../editParameterValue.vue";
import mainElementsGenericComponent from "./mainElementsGeneric.vue";
import mainElements60Component from "./60/mainElements60.vue";
import mainElements66Component from "./mainElements66.vue";
import mainElements67Component from "./mainElements67.vue";
import mainElements68Component from "./mainElements68.vue";
import mainElements66simetricComponent from "./mainElements66simetric.vue";
import mainElements67simetricComponent from "./mainElements67simetric.vue";
import mainElements93Component from "./mainElements93.vue";
import mainElements73Component from "./mainElements73.vue";
import mainElements73aComponent from "./mainElements73a.vue";
import mainElements74Component from "./mainElements74.vue";
import mainElements78Component from "./mainElements78.vue";
import mainElements31Component from "./mainElements31.vue";
import mainElements30Component from "./mainElements30.vue";
import mainElements50cComponent from "./mainElements50c.vue";
import mainElements50tComponent from "./mainElements50t.vue";
import mainElements51Component from "./mainElements51.vue";
import mainElements52Component from "./mainElements52.vue";
import mainElements80Component from "./mainElements80.vue";
import navigation from "../common/navigation.vue";

export default {
    name: "mainElementsComponent",
    data() {
        return {
            app: app,
            confirmBeforeLeave: true,
            parameters: [],
            mainElementDistribution: "",
            labelOverDropdown: true,
            idgama: "",
            idsolucionconstructiva: "",
            buttonLoading: false,
            window: { width: 0, height: 0 },
        };
    },
    components: {
        navigation,
        editParameterValueComponent,
        mainElementsGenericComponent,
        mainElements60Component,
        mainElements66Component,
        mainElements66simetricComponent,
        mainElements67simetricComponent,
        mainElements67Component,
        mainElements93Component,
        mainElements73Component,
        mainElements73aComponent,
        mainElements74Component,
        mainElements78Component,
        mainElements31Component,
        mainElements30Component,
        mainElements50cComponent,
        mainElements50tComponent,
        mainElements51Component,
        mainElements52Component,
        mainElements80Component,
        mainElements68Component
    },
    methods: {

        selectedAllFamilyParams: function () {
            let all_famParams_are_selected = true;

            Object.entries(
                this.app.currentConfiguration.familyParameters
            ).forEach(([key, value]) => {
                if (value.valueString == "") {
                    all_famParams_are_selected = false;
                }
            });

            return all_famParams_are_selected;
        },

        cleanAllSelectors: async function () {
            var self = this;

            app.showSpinner();

            if (this.idgama == '66' || this.idgama == '67') {
                self.app.currentConfiguration.mainElementParameters = [];

            } else {
                let mainparams = this.app.currentConfiguration.mainElementParameters;

                Object.values(mainparams).map((mainparam) => {
                    Object.values(mainparam).map((item) => {
                        if (item.value.constructor.name == "Array") {
                            item.value = [];
                        } else {
                            item.value = "";
                        }
                    });
                });

            }

            //delete value commonMainElementParameters
            let commonMainParams = this.app.currentConfiguration.commonMainElementParameters;

            Object.values(commonMainParams).map((commonMainParam) => {
                if (commonMainParam.value.constructor.name == "Array") {
                    commonMainParam.value = [];
                } else {
                    commonMainParam.value = "";
                }
            });

            self.$emit("clearCheckboxes");

            await self.refreshParameters();

            app.hideSpinner();

        },
        updateWindowSize() {
            this.window_width = window.innerWidth;
        },
        handleResize() {
            this.window.width = window.innerWidth;
            this.window.height = window.innerHeight;
        },
        navigate_p4: async function () {
            try {
                this.buttonLoading = true;
                await this.app.navigateToNextStage();

                this.buttonLoading = false;
            } catch (error) {
                this.buttonLoading = false;
            }
        },
        navigate_p2: async function () {
            try {
                this.buttonLoading = true;
                app.navigateToStageAsync("2");

                this.buttonLoading = false;
            } catch (error) {
                this.buttonLoading = false;
            }
        },
        refreshParameters: async function () {
            await this.app.asyncProcess(false, false);
        },
    },

    computed: {

        withSoporteTrapecio: function () {
            if (this.solConstructiva.id === "10-t_tra") return true;
        },

        isWall: function () {
            var parent_id = this.solConstructiva.parent_id;

            if (parent_id.includes("10-p")) return true;

            return false;
        },
        isFloor: function () {

            var parent_id = this.solConstructiva.parent_id;

            if (parent_id.includes("10-s")) return true;

            return false;
        },
        isCeiling: function () {
            var parent_id = this.solConstructiva.parent_id;

            if (parent_id.includes("10-t")) return true;

            return false;
        },
        isMobile: function () {
            let a = this.window.width < 750;
            return a;
        },
        selectedAllParameters: function () {
            let all_mainElement_are_selected = true;

            Object.entries(
                this.app.currentConfiguration.mainElementParameters
            ).forEach(([key, value]) => {

                Object.entries(value).forEach(([key, value2]) => {

                    if (value2.valueString == "") {
                        all_mainElement_are_selected = false;
                    }
                });
            });

            Object.entries(
                this.app.currentConfiguration.commonMainElementParameters
            ).forEach(([key, value]) => {
                if (value.valueString == "") {
                    all_mainElement_are_selected = false;
                }
            });

            return all_mainElement_are_selected;
        },
    },

    created() {

        this.idgama = this.app.currentConfiguration.familyParameters["gama"].value.id;

        if (
            this.app.currentConfiguration.stage === 3 &&
            (this.idgama == '73' || this.idgama == '93')
        ) {
            this.app.isSpinnerAlwaysVisible = true;
        }

        this.solConstructiva = this.app.currentConfiguration.familyParameters[
            "sol_constructiva"
        ].value;

        this.idsolucionconstructiva =
            this.app.currentConfiguration.familyParameters[
                "sol_constructiva"
            ].value.id;

        //get window size
        window.addEventListener("resize", this.handleResize);
        this.handleResize();
    },

    destroyed() {
        window.removeEventListener("resize", this.handleResize);
    },
};
</script>

<style scoped lang="scss" scoped>
.sticky_buttons {
    position: sticky;
    top: 135px;
    z-index: 999;
    height: 70px;
    background-color: white;
}

.btn_bottom_width {
    width: 270px;
}
</style>
